import { render } from "./linode.vue?vue&type=template&id=5c05dc48"
import script from "./linode.vue?vue&type=script&lang=js"
export * from "./linode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__